import React, { memo } from 'react';

import styled from 'styled-components';

import { careerColor } from 'services/careerTokens';
import { careerLayout } from 'services/careerType';

/**
 * Скелет главной (ТЗ «визуальное упрощение», 8.4): те же блоки и высоты, что у
 * загруженной страницы — заголовок, цель, карточка действия, четыре этапа, —
 * чтобы при приходе данных ничего не прыгало.
 *
 * Без анимации: мерцание на rAF в фоновой вкладке не идёт, а статичные серые
 * плашки читаются как «загружается» и так.
 */
export const CareerPlanSkeleton = memo(() => (
  <Wrapper aria-busy="true" aria-live="polite">
    <Bar $w="40%" $h={40} />
    <Bar $w="60%" $h={20} />
    <Gap />
    <Bar $w="30%" $h={20} />
    <Bar $w="45%" $h={30} />
    <Gap />
    <Card>
      <Bar $w="20%" $h={20} />
      <Bar $w="55%" $h={32} />
      <Bar $w="35%" $h={20} />
      <Bar $w="160px" $h={48} />
    </Card>
    <Gap />
    <Bar $w="25%" $h={28} />
    {[0, 1, 2, 3].map((row) => (
      <Row key={row}>
        <Bar $w="40%" $h={26} />
      </Row>
    ))}
  </Wrapper>
));

const Wrapper = styled.div`
  width: 100%;
  max-width: ${careerLayout.planWidth}px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 8px;
`;

const Bar = styled.span<{ $w: string; $h: number }>`
  display: block;
  width: ${({ $w }) => $w};
  max-width: 100%;
  height: ${({ $h }) => $h}px;
  border-radius: 6px;
  background: ${careerColor.line};
`;

const Gap = styled.span`
  display: block;
  height: 16px;
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 24px;
  border: 1px solid ${careerColor.line};
  border-radius: ${careerLayout.cardRadius}px;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  min-height: 72px;
  border-top: 1px solid ${careerColor.line};
`;
